// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nAaN","col":"styles_col__Lbb9C"};